export const LOCATION_SEARCH_MACHINE_MINIMAL_CHARACTERS_FOR_SEARCH = 3;
export const LOCATION_SEARCH_MACHINE_DEBOUNCE_DELAY_MS = 300;
export const LOCATION_SEARCH_MACHINE_MINIMUM_RADIUS_MILES = 2;
